<template>
	<RouterView />
</template>

<script>
import { useMortgageStore } from './stores/mortgageStore.js';

export default {
	watch: {
		'$route.name'(newName, oldName) {
			if (newName !== undefined) {
				const mortgageStore = useMortgageStore();
				let dataLayerObject = {
					'event': 'MortgageAppointmentStep',
					'step': newName, //The step name given after the # in the URL
				}
				if (oldName === 'mortgage-details') {
					dataLayerObject.mortgageType = mortgageStore?.mortgageType;
					dataLayerObject.remortgage = mortgageStore?.remortgage;
					dataLayerObject.propertySearchStage = mortgageStore?.propertySearchStage;
					dataLayerObject.findingMortgageOrCheckingBorrowingAmount = mortgageStore?.findingOrCheckingBorrowingAmount;
				}
				else if (oldName === 'current-mortgage') {
					dataLayerObject.previousMortgageProvider = mortgageStore?.previousMortgageProvider;
					dataLayerObject.mortgageDealEnding = mortgageStore?.mortgageDealEnding;
				}
				else if (oldName === 'remortgaging-needs') {
					dataLayerObject.increaseBorrowing = mortgageStore?.increaseBorrowing;
					dataLayerObject.borrowingAmount = mortgageStore?.borrowingAmount;
				}
				setTimeout(() => {
					if (window.dataLayer) {
						window.dataLayer.push(dataLayerObject);
					}
				}, 500)
			}
		}
	}
}
</script>

<style scoped></style>
